import type { ApolloError } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';
import type {
  DealPromptPricingQueryResult,
  NormalizeDefinitionType,
} from '@openx/components-deal-prompt/lib/utils/types.ts';
import { useCallback } from 'react';
import {
  GetAudiencePricingDocument,
  type GetAudiencePricingQuery,
} from '../../../graphql/query/audiences/GetAudiencePricing.generated.tsx';

export const useDealPromptPricing = () => {
  const [fetchDealPromptPricingLazy] = useLazyQuery<GetAudiencePricingQuery>(GetAudiencePricingDocument);

  const fetchDealPromptPricing = useCallback(
    async ({
      accountId,
      normalizedDefinition,
    }: {
      accountId: string;
      normalizedDefinition: NormalizeDefinitionType;
    }): Promise<{
      data: DealPromptPricingQueryResult | undefined;
      error?: ApolloError;
    }> => {
      const result = await fetchDealPromptPricingLazy({
        variables: {
          accountId,
          normalizedDefinition,
        },
      });

      return {
        data: result.data,
        error: result.error,
      };
    },
    [fetchDealPromptPricingLazy]
  );

  return {
    fetchDealPromptPricing,
  };
};
